import { useTheme, type ThemeMode } from '../hooks/useTheme';
import { useTranslation } from '../i18n';

/**
 * 3-state theme toggle — light · dark · system.
 * Inline icon glyphs (no extra deps).
 * Cycles light → dark → system on click.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { mode, toggle } = useTheme();

  const label =
    mode === 'light' ? t('theme.light') :
    mode === 'dark'  ? t('theme.dark')  :
                       t('theme.system');

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={`${t('theme.label')}: ${label}`}
      title={label}
    >
      <span aria-hidden="true" className={`theme-toggle__icon theme-toggle__icon--${mode}`}>
        {ICON[mode]}
      </span>
    </button>
  );
}

const ICON: Record<ThemeMode, JSX.Element> = {
  light: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  dark: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  ),
  system: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  ),
};
